import { HubConnection } from '@microsoft/signalr'

export const startSignalRCommunication = async (connection: HubConnection) => {
    await connection.start()
    console.log('SignalR connection success')
}
